import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TransactionHistoryComponent } from 'src/app/Account/transaction-history/transaction-history.component';
import { AddCustomerComponent } from 'src/app/AddThings/add-customer/add-customer.component';
import { AddLoanComponent } from 'src/app/AddThings/add-loan/add-loan.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { TaskCollectionListComponent } from 'src/app/Others/task-collection-list/task-collection-list.component';
import { DataService } from 'src/app/Shared/data.service';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Customer } from 'src/model/customer.model';
import { EPF } from 'src/model/epf.model';
import { LoanRequest } from 'src/model/loanRequest.model';
import { Profile } from 'src/model/profile.model';
import { SharedLoanCompany, SharedLoanRequest } from 'src/model/sharedLoan.model';
import { Task } from 'src/model/task.model';
import { TransactionRequest } from 'src/model/transactionRequest.model';
import { LoanRequestService } from 'src/services/loan-request.service';
import { MidMonthService } from 'src/services/mid-month.service';
import { CustomerService } from 'src/services/customer.service';

@Component({
    selector: 'app-dashboard-calendar',
    templateUrl: './dashboard-calendar.component.html',
    styleUrls: ['./dashboard-calendar.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class DashboardCalendarComponent implements OnInit, OnDestroy {
  private cdr = inject(ChangeDetectorRef);
  protected datepipe = inject(DatePipe);
  private router = inject(Router);
  private dataService = inject(DataService);
  private restapi = inject(RestApiService);
  private constructAPI = inject(ConstructAPI);
  private enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private customerService = inject(CustomerService);
  private midMonthService = inject(MidMonthService);
  private loanRequestService = inject(LoanRequestService);


  // loggedInUserId: string;
  loggedInUsername: string;
  loggedInComp: string;

  sortAsc = true;

  searchText: string;
  calendarDate: Date = new Date();

  model: any;


  taskList: Task[] = [];
  wholeTaskList: Task[] = [];

  leadList: Customer[] = [];
  wholeLeadList: Customer[] = [];

  transactionRequestList: TransactionRequest[] = [];

  todayTotalTask = 0;
  todayPendingTask = 0;

  userCashAccount: Account;

  totalLoanCount: number;
  totalLoanAmount: number;
  leadSubscription: any;
  showTask = false;

  loanRequestList: LoanRequest[] = [];

  expenseOutTotal = 0;
  dlExpenseOutTotal = 0;

  sharedLoanRequestList: SharedLoanRequest[] = [];

  midMonthLink = '';

  ngOnInit() {

    this.loggedInUsername = sessionStorage.getItem("username");
    this.loggedInComp = sessionStorage.getItem("companyId");

    this.getAllLeads();
    this.wholeLeadList = this.leadList;

    //subscribe to new lead data if any new lead is added
    this.leadSubscription = this.dataService.currentLeadList.subscribe(data => {

      //if there is any new lead
      if (data != undefined && data.length > 0) {

        //add the lead into lead list
        // this.leadList.push(data[0]);


        //UI detect changes
        // this.cdr.detectChanges();
      }

    })

    this.getLoanSummary();
    this.getAccountDetails();

    //get all HQ Assigned transactions, only manager and BOOK KEEPING STAFFS can get
    if (this.sharedService.isStaff() == false)
      this.getAllAssignedTransactionList();

    // if (this.sharedService.isBranchManager())
    this.getAllLoanRequests(new Date().toISOString());

    this.getAllSharedLoanAgreements();

    //if is staff show task details
    //other than staff show expenses details
    if (this.sharedService.isStaff() || this.sharedService.isBookkeepingStaff())
      this.calculateTodayTasks(this.taskList);
    else
      this.getExpensesDetailsOfTheMonth();

    this.midMonthLink = this.midMonthService.getMidMonthLink(this.loggedInComp);
  }

  ngOnDestroy() {
    this.leadSubscription.unsubscribe();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    if (filterValue != "") {

      const value = filterValue.replace(/-/g, '');
      this.leadList = this.wholeLeadList.filter((lead: Customer) => (lead.Name.toString().toUpperCase().includes(value.toUpperCase()) || lead.ICNumber.toString().includes(value)))
    } else
      this.leadList = this.wholeLeadList;

  }
  loadTaskList() {
    const date = this.datepipe.transform(new Date(), 'yyyy-MM-dd');

    this.getAllTasks(date);
    this.wholeTaskList = this.taskList;
    this.showTask = true;

  }

  hideTaskList() {

    //RESET TASK COUNTS
    this.todayTotalTask = 0;
    this.todayPendingTask = 0;

    this.wholeTaskList = [];
    this.taskList = [];
    this.showTask = false;
  }

  addTaskStyle(taskDate: Date, isDone: boolean) {

    const taskDateFormat = new Date(taskDate);
    // alert(doneDate)
    if (taskDateFormat < this.calendarDate && isDone == false) {
      return "pendingTaskCard";
    }

  }


  getStatusColor(isDone: boolean) {

    // alert(dateDone)
    let color: string;

    switch (isDone) {
      case false:
        color = "red";
        break;

      default:
        color = "green";
        break;
    }
    return color;
  }

  filterListByDate() {

    this.showTask = true;
    //RESET TASK COUNTS
    this.todayTotalTask = 0;
    this.todayPendingTask = 0;
    //clear task list
    this.taskList.splice(0, this.taskList.length)

    if (this.calendarDate != null) {

      const calendar = new Date(this.datepipe.transform(this.calendarDate, 'yyyy-MM-dd'));
      const calendarFormat = this.datepipe.transform(this.calendarDate, 'yyyy-MM-dd');
      // var taskDate = new Date(this.datepipe.transform(this.wholeTaskList[0].Date, 'yyyy-MM-dd'));

      // console.log("Calendar:" + calendar);
      // console.log("taskDate:" + taskDate);

      // console.log("Calendar<taskDate?" + (calendar < taskDate));

      //filter task by date
      // this.taskList = this.wholeTaskList.filter((task: Task) => new Date(this.datepipe.transform(task.Date, 'yyyy-MM-dd')) <= calendar);



      //get task list by date
      this.getAllTasks(calendarFormat);

      this.taskList.sort((a, b) => (a.Date > b.Date) ? 1 : -1);

    }
  }

  calculateTodayTasks(taskList: Task[]) {

    this.todayTotalTask = taskList.length;


    taskList.forEach(task => {
      if (task.IsDone == false)
        this.todayPendingTask++;

    });
  }
  filterList() {

    if (this.searchText != "") {
      // console.log("search:" + this.searchText);
      this.taskList = this.wholeTaskList.filter((task: Task) => (task.Description.toUpperCase().includes(this.searchText.toUpperCase())) || task.CustomerName.toString().toUpperCase().includes(this.searchText.toUpperCase()));
    }

    else
      this.taskList = this.wholeTaskList;
  }
  sortList(sortCriteria: string) {

    // console.log(this.taskList)
    if (this.sortAsc == true) {
      switch (sortCriteria) {

        case 'status':
          this.taskList.sort((a, b) => ((a.IsDone > b.IsDone)) ? 1 : -1);
          break;
        case 'name':
          this.taskList.sort((a, b) => (a.CustomerName > b.CustomerName) ? 1 : -1);
          break;
        case 'desc':
          this.taskList.sort((a, b) => (a.Description > b.Description) ? 1 : -1);
          break;
        case 'date':
          this.taskList.sort((a, b) => (a.Date > b.Date) ? 1 : -1);
          break;

      }

    }

    else {
      switch (sortCriteria) {

        case 'status':
          this.taskList.sort((a, b) => ((a.IsDone < b.IsDone)) ? 1 : -1);
          break;
        case 'name':
          this.taskList.sort((a, b) => (a.CustomerId < b.CustomerId) ? 1 : -1);
          break;
        case 'desc':
          this.taskList.sort((a, b) => (a.Description < b.Description) ? 1 : -1);
          break;
        case 'date':
          this.taskList.sort((a, b) => (a.Date < b.Date) ? 1 : -1);
          break;


      }

    }


    this.sortAsc = !this.sortAsc;

  }


  viewTaskDetails(taskId: number, customerId: number, profileId: number) {

    this.router.navigate(['/taskDetails', taskId, customerId, profileId]);
  }

  notOwnTask(assignee: string) {
    const username = sessionStorage.getItem("username");

    if (assignee != username)
      return true;

    else false;
  }


  async getAllSharedLoanAgreements() {
    if (this.sharedService.isBranchManager())
      this.sharedLoanRequestList = await this.loanRequestService.getAllSharedLoanApprovalRequest({ processed: false });
    this.cdr.detectChanges();
  }

  async getAllLoanRequests(endDate: string) {
    this.loanRequestList = await (this.sharedService.isBranchManager() ? this.loanRequestService.getAllLoanApprovalRequest({ endDate: endDate, withLoan: false }) : this.loanRequestService.getAllLoanApprovalRequest({ endDate: endDate, withLoan: false, authorized: false }));
    this.loanRequestList.sort((a, b) => ((a.AuthorizedBy > b.AuthorizedBy)) ? -1 : 1);
    this.cdr.detectChanges();
  }


  getAllTasks(date: string) {

    const xhttp = this.restapi.getRequest(this.constructAPI.getTasksForAday(date))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:

        const jsonArray = JSON.parse((xhttp.responseText));
        // console.log(jsonArray);

        jsonArray.forEach(json => {

          const isDone = (json.dateDone == undefined) ? false : true;
          const task = new Task(json.id, json.customerId,
            json.description, json.followUpRemark, json.date, json.customerName, json.assignee, json.dateDone, isDone, json.profileId);


          this.taskList.push(task);
        }

        );

        this.calculateTodayTasks(this.taskList);
      }
    };

  }

  getLoanSummary() {
    const dateNow = new Date();

    const userRole = Number(sessionStorage.getItem("roleId"));
    const apiEndpoint = (userRole == this.enums.BRANCH_MANAGER) ? this.constructAPI.getYearMonthLoanStat(dateNow.getFullYear(), dateNow.getMonth() + 1)
      : this.constructAPI.getUserYearMonthLoanStat(this.loggedInUsername, dateNow.getFullYear(), dateNow.getMonth() + 1);
    const xhttp = this.restapi.getRequest(apiEndpoint)

    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:

        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(
          json => {
            this.totalLoanAmount = json.amount;
            this.totalLoanCount = json.count;
          }
        );

      }
    };
  }

  getAccountDetails() {

    const xhttp = this.restapi.getRequest(this.constructAPI.getUserCashAccount(this.loggedInUsername))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:

        const json = JSON.parse((xhttp.responseText));
        // console.log(jsonArray);

        this.userCashAccount = new Account(json.id, json.number, json.name, null, json.balance, json.companyId, json.username, null);

      }
    };

  }

  async getAllLeads() {
    this.leadList = await this.customerService.getAllLeadsProfiles();
    this.wholeLeadList = this.leadList;
  }

  openTransactionHistoryModal() {
    const modalRef = this.sharedService.openModal(TransactionHistoryComponent, "largeModal");

    modalRef.componentInstance.accountId = this.userCashAccount.ID;


  }


  openAddCustomerModal() {
    const modalRef = this.sharedService.openModal(AddCustomerComponent, "largeModal");

    //get customer that was created
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      window.location.reload();
    });
  }

  goToCustomer(lead: Customer) {
    this.router.navigate(['/manageCustomer', lead.ID]);
  }

  openAddLoanModal(lead: Customer) {

    const modalRef = this.sharedService.openModal(AddLoanComponent, "largeModal");
    modalRef.componentInstance.selectedCustomer = lead;
    modalRef.componentInstance.selectedProfile = lead.Profiles[0];
    modalRef.componentInstance.isLead = true;
    const epf = new EPF(undefined, undefined, undefined, undefined, undefined, undefined, undefined)
    modalRef.componentInstance.epfDetails = epf;

    modalRef.componentInstance.isEPFExtra = false;
    modalRef.componentInstance.previousEPFLoans = undefined;


    modalRef.componentInstance.needRestrictedRequest = this.sharedService.checkIsSeniorRestrictedCustomer(new Date(lead.DOB));

    // modalRef.componentInstance.allowEPF = this.sharedService.checkIsAllowEPF(lead.DOB, epf);

    //get customerID for lead that deals
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      const profileId = entry.ProfileId;

      //remove the customer from lead list
      const index = this.leadList.findIndex(lead => lead.Profiles[0].ID === profileId);
      this.leadList.splice(index, 1);
    });

    modalRef.result.then(() => {

      //detect changes
      this.cdr.detectChanges();
    })
  }


  openTaskCollectionModal() {
    const modalRef = this.sharedService.openModal(TaskCollectionListComponent, 'largeModal');
    modalRef.componentInstance.selectedDate = this.calendarDate;
  }


  getAllAssignedTransactionList() {
    //only get trasactionRequest without transaction
    const xhttp = this.restapi.getRequest(this.constructAPI.getAllTransactionRequests(false))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {

        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {

          const itemsArray = json.items;
          const itemList = [];
          itemsArray.forEach(itemJson => {
            const item = { "amount": itemJson.amount, "type": itemJson.type, "subtype": itemJson.subtype }

            itemList.push(item);
          }
          );

          const transactionRequest = new TransactionRequest(json.id, json.companyCode, json.companyid, json.remark, json.requestedBy, json.requestedOn, itemList);
          this.transactionRequestList.push(transactionRequest);
        }
        );
      }
    };
  }


  getExpensesDetailsOfTheMonth() {

    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const endDate = new Date();

    const companyId = Number(sessionStorage.getItem('companyId'));
    //only get trasactionRequest without transaction
    const xhttp = this.restapi.getRequest(this.constructAPI.getCompanyTransactionDetails(companyId, startDate.toISOString(), endDate.toISOString(), [this.enums.EXPENSE]))


    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {

        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          this.expenseOutTotal = -Number(json.out);
        }
        );

        this.getExpensesDLDetailsOfTheMonth();
      }
    };
  }

  getExpensesDLDetailsOfTheMonth() {

    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const endDate = new Date();

    const companyId = Number(sessionStorage.getItem('companyId'));
    //only get trasactionRequest without transaction
    const xhttp = this.restapi.getRequest(this.constructAPI.getCompanyTransactionDetails(companyId, startDate.toISOString(), endDate.toISOString(), [this.enums.EXTRAS]))


    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {

        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          this.dlExpenseOutTotal = -Number(json.out);
        }
        );
      }
    };
  }

  goToExpenseReport() {
    const companyId = Number(sessionStorage.getItem("companyId"));

    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const endDate = new Date();

    this.router.navigate(['/simpleReport', companyId, this.enums.EXPENSE_REPORT, startDate.toISOString(), endDate.toISOString()]);
  }
}